// Skeleton placeholders keep the page's shape while content loads, so the
// layout doesn't jump when it arrives.

export function SkeletonBlock({ className }: { className: string }) {
  return (
    <div
      aria-hidden="true"
      className={`animate-shimmer rounded-lg ${className}`}
    />
  );
}

// SkeletonStoryRows mirrors a StoryRows list.
export function SkeletonStoryRows({ count = 5 }: { count?: number }) {
  return (
    <div
      className="card divide-y divide-border overflow-hidden"
      aria-hidden="true"
    >
      {Array.from({ length: count }, (_, idx) => (
        <div key={idx} className="flex items-center gap-3 px-3 py-2.5 sm:px-4">
          <SkeletonBlock className="h-[52px] w-10 shrink-0 rounded-[5px]" />
          <div className="flex flex-grow flex-col gap-2">
            <SkeletonBlock className="h-4 w-3/5" />
            <SkeletonBlock className="h-3 w-12" />
          </div>
        </div>
      ))}
    </div>
  );
}
